import React from 'react';
import {
  Collapse,
  Grid,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { useBusinessCard } from './BusinessCard';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  collapse: {
    direction: 'rtl',
    width: '100%',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  },
}));
const Bio = () => {
  const styles = useStyles();
  const {
    tab,
    card: { bio, businessBio, textColor },
    dimensions: { vw },
  } = useBusinessCard();
  return (
    <Collapse in={tab === 'bio'} className={styles.collapse}>
      <Grid
        item
        xs={12}
        style={{
          marginBottom: vw(16),
          paddingRight: vw(8),
          paddingLeft: vw(8),
          paddingTop: 0,
        }}
      >
        <List>
          {/*{bio && (*/}
          {/*  <ListItem>*/}
          {/*    <ListItemText*/}
          {/*      primary="על עצמי"*/}
          {/*      secondary={bio}*/}
          {/*      secondaryTypographyProps={{ style: { color: textColor } }}*/}
          {/*    />*/}
          {/*  </ListItem>*/}
          {/*)}*/}
          {businessBio && (
            <ListItem>
              <ListItemText
                primary="על העסק"
                secondary={businessBio}
                secondaryTypographyProps={{ style: { color: textColor } }}
              />
            </ListItem>
          )}
        </List>
      </Grid>
    </Collapse>
  );
};

export default Bio;
